import { useEffect, useState } from "react";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

export default function useExternalAuth({ auth_provider, tool_id }) {
  const baseUrl = getHostDomain();
  const [auths, setAuths] = useState([]);
  const [status, setStatus] = useState("idle");
  const fetchToolUsers = async () => {
    try {
      if (!auth_provider && !tool_id) {
        setAuths([]);
        return;
      }
      setStatus("loading");
      const url = tool_id
        ? `/api/v1/external_auth/provider_auth?tool_id=${tool_id}&size=100`
        : `/api/v1/external_auth/provider_auth?auth_provider=${auth_provider}&size=100`;

      const response = await fetchController(baseUrl + url);
      setAuths(response);
    } catch (error) {
      console.error(error)
    } finally {
      setStatus("idle");
    }
  };

  useEffect(() => {
    fetchToolUsers();
  }, [auth_provider, tool_id]);

  return { auths, refreshAuths: fetchToolUsers, status };
}
